export const imgBackEnd = "https://smart-mobility.info/";